/** Timers — edit view (delegates to the shared TimerForm). */
import { TimerForm } from "./_TimerForm";

export function TimerEdit() {
  return <TimerForm action="edit" />;
}

export default TimerEdit;
